// Auto-generated from backend schema
// DO NOT EDIT MANUALLY - regenerate with: python scripts/generate-field-config.py
// Run: python scripts/generate-field-config.py

import type { HookId, HookDefinition, FeatureGroupId } from '../hooks-registry';
import type { TabId } from '../tabConfig';

/**
 * Generated hook definitions from backend Pydantic schema.
 * These should be merged with manual definitions in hooks-registry.ts
 */
export const GENERATED_MODEL_HOOKS: Record<string, HookDefinition> = {
  device: {
    id: 'device' as HookId,
    displayName: '启用设备感知',
    description: 'device hook 配置 - 设备感知上下文  从 push_tokens（优先）和 users_preference（补充）获取用户设备信息， 注入到 System Prompt 帮助 Agent 理解用户使用环境。  Stage: SYSTEM (runs once at agent creation)',
    group: 'core' as FeatureGroupId,
    configPath: 'hooks.device.enabled',
    linkedTab: 'basic' as TabId,
    linkedSection: 'context_awareness',
    isVirtual: false,
    directToggle: true,
  },
  location: {
    id: 'location' as HookId,
    displayName: '启用位置感知',
    description: 'location hook 配置 - 位置感知上下文  从 users_preference 获取用户位置信息， 注入到 System Prompt 帮助 Agent 提供本地化响应。  Stage: SYSTEM (runs once at agent creation)',
    group: 'core' as FeatureGroupId,
    configPath: 'hooks.location.enabled',
    linkedTab: 'basic' as TabId,
    linkedSection: 'context_awareness',
    isVirtual: false,
    directToggle: true,
  },
  quick_chat: {
    id: 'quick_chat' as HookId,
    displayName: '启用快速响应',
    description: 'quick_chat hook 配置 - 快速响应能力开关  控制是否启用快速模型处理简单问候和确认。当启用时，使用 models.chat.quick_model_id 和 models.vision.quick_model_id。 默认启用(True)以保持向后兼容——旧配置无此字段时隐式启用了快速响应。',
    group: 'models' as FeatureGroupId,
    configPath: 'hooks.quick_chat.enabled',
    linkedTab: 'basic' as TabId,
    linkedSection: 'models',
    isVirtual: false,
    directToggle: true,
  },
  reasoning: {
    id: 'reasoning' as HookId,
    displayName: '启用推理能力',
    description: 'reasoning hook 配置 - 推理能力开关  控制是否启用扩展思考/推理功能。 - mode: 推理模式 (\'disabled\', \'native\', \'combined\')',
    group: 'models' as FeatureGroupId,
    configPath: 'hooks.reasoning.enabled',
    linkedTab: 'basic' as TabId,
    linkedSection: 'models_reasoning',
    isVirtual: false,
    directToggle: true,
  },
  reranking: {
    id: 'reranking' as HookId,
    displayName: '启用重排序',
    description: 'reranking hook 配置 - 重排序能力开关  控制是否启用搜索结果重排序功能。当启用时，使用 models.reranking.model_id 重排序。',
    group: 'models' as FeatureGroupId,
    configPath: 'hooks.reranking.enabled',
    linkedTab: 'basic' as TabId,
    linkedSection: 'models_reranking',
    isVirtual: false,
    directToggle: true,
  },
  stt: {
    id: 'stt' as HookId,
    displayName: '启用语音输入',
    description: 'stt hook 配置 - 语音输入能力开关  控制是否启用语音转文字功能。当启用时，使用 models.stt.model_id 处理语音。',
    group: 'models' as FeatureGroupId,
    configPath: 'hooks.stt.enabled',
    linkedTab: 'basic' as TabId,
    linkedSection: 'models_stt',
    isVirtual: false,
    directToggle: true,
  },
  vision: {
    id: 'vision' as HookId,
    displayName: '启用视觉模型',
    description: 'vision hook 配置 - 视觉模型开关  控制是否启用视觉/多模态功能。当启用时，使用 models.vision.model_id 处理图片。',
    group: 'models' as FeatureGroupId,
    configPath: 'hooks.vision.enabled',
    linkedTab: 'basic' as TabId,
    linkedSection: 'models_vision',
    isVirtual: false,
    directToggle: true,
  },
};
